import React from "react";
import { Modal, Box, Typography, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { FaTrash, FaTimes } from "react-icons/fa";

const styles = (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
  },
  modalContent: {
    position: "relative",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 16px 48px rgba(0, 0, 0, 0.2)",
    padding: "24px",
    minWidth: "380px",
    maxWidth: "450px",
    outline: "none",
    textAlign: "center",
  },
  title: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "12px",
    color: "#2c3e50",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  message: {
    fontSize: "14px",
    color: "#6c757d",
    marginBottom: "24px",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    lineHeight: 1.5,
  },
  buttonContainer: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
  },
  confirmButton: {
    padding: "10px 20px",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "500",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "&:hover": {
      backgroundColor: "#c82333",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(220, 53, 69, 0.3)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },
  cancelButton: {
    padding: "10px 20px",
    backgroundColor: "transparent",
    color: "#6c757d",
    border: "1px solid #dee2e6",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "500",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    "&:hover": {
      backgroundColor: "#f8f9fa",
      borderColor: "#adb5bd",
      transform: "translateY(-1px)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },
  trashIcon: {
    fontSize: "20px",
    color: "#dc3545",
  },
});

class ConfirmacaoRemocaoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      title: "",
      message: "",
      onConfirm: null,
      onCancel: null,
    };
  }

  componentDidMount() {
    window.showConfirmRemocaoModal = this.showConfirmRemocaoModal;
  }

  componentWillUnmount() {
    delete window.showConfirmRemocaoModal;
  }

  showConfirmRemocaoModal = (title, message, onConfirm, onCancel) => {
    this.setState({
      isOpen: true,
      title,
      message,
      onConfirm,
      onCancel,
    });
  };

  handleConfirm = () => {
    const { onConfirm } = this.state;
    this.setState({ isOpen: false });
    if (onConfirm) {
      onConfirm();
    }
  };

  handleCancel = () => {
    const { onCancel } = this.state;
    this.setState({ isOpen: false });
    if (onCancel) {
      onCancel();
    }
  };

  handleModalClose = (event, reason) => {
    return;
  };

  render() {
    const { classes } = this.props;
    const { isOpen, title, message } = this.state;

    return (
      <Modal
        open={isOpen}
        className={classes.modal}
        disableEscapeKeyDown={true}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          this.handleModalClose(event, reason);
        }}
        onKeyDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Box className={classes.modalContent}>
          <Typography className={classes.title}>
            <FaTrash className={classes.trashIcon} />
            {title}
          </Typography>

          <Typography className={classes.message}>{message}</Typography>

          <div className={classes.buttonContainer}>
            <Button
              className={classes.cancelButton}
              onClick={this.handleCancel}
            >
              <FaTimes />
              Cancelar
            </Button>
            <Button
              className={classes.confirmButton}
              onClick={this.handleConfirm}
            >
              <FaTrash />
              Remover
            </Button>
          </div>
        </Box>
      </Modal>
    );
  }
}

export default withStyles(styles)(ConfirmacaoRemocaoModal);
